import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';
import SvgImage from '../SvgImage';
import './styles.scss';

interface SocialLinksProps {
  list: {
    name: string;
    url: string;
    type: string;
  }[];
}

const SocialLinks = ({ list }: SocialLinksProps) => (
  <div className="social-links">
    <ul className="social-links__list">
      {list.map((item) => (
        <li key={uuidv4()} className="social-links__item">
          <a className="social-links__link" href={item.url} target="_blank" rel="noreferrer">
            <span>{item.name}</span>
            <div className="social-links__link-icon">
              <SvgImage title={item.type} reference={`#icon-${item.type}`} />
            </div>
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default SocialLinks;
